import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, map, of, switchMap } from 'rxjs';
import { AuthenticateEmail, GotoVerifyEmail } from './email-authentication.actions';
import { EmailAuthenticationState } from './email-authentication.state';

@Injectable({
  providedIn: 'root'
})
export class EmailAuthenticationService {
  constructor(private store: Store) {}

  checkEmailAndReturnInputRequired(email: string, autostart: boolean = false, redirectUrl?: string): Observable<boolean> {
    return this.store
      .dispatch(new AuthenticateEmail(email, redirectUrl, autostart))
      .pipe(
        switchMap(() =>
          this.store.selectSnapshot(EmailAuthenticationState.passwordRequired) || !this.store.selectSnapshot(EmailAuthenticationState.email)
            ? of(true)
            : this.store.dispatch(new GotoVerifyEmail({ autostartPage: autostart })).pipe(map(() => false))
        )
      );
  }
}
